import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrTypeaheadComponent } from './tr-typeahead.component';

@NgModule({
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    imports: [ CommonModule ],
    exports: [ TrTypeaheadComponent ],
    declarations: [ TrTypeaheadComponent ],
})
export class TrTypeaheadModule {}
